import styles from "./styles.module.css";

import React from "react";

export const TimePeriod = ({ timePeriod, nextTimePeriod, lastTimePeriod }) => {
  // начальная дата периуда
  let dateStart = new Date(timePeriod.statr);
  // текстовое предстовление начальной даты периуда
  dateStart = dateStart.toLocaleDateString("ru-Ru", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  // конченая дата периуда
  let dateFinish = new Date(timePeriod.finish);
  // текстоввое предстовление конечной даты периуда
  dateFinish = dateFinish.toLocaleDateString("ru-Ru", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  // ?<--------------------------------------------------------------------------------------------------------------->

  return (
    <div className={styles.periodBlock}>
      <div className={styles.prev}>
        <i onClick={lastTimePeriod} className={styles.gg_arrow_left_o}></i>
      </div>
      <div className={styles.period}>
        {dateStart} - {dateFinish}
      </div>
      <div className={styles.next}>
        <i onClick={nextTimePeriod} className={styles.gg_arrow_right_o}></i>
      </div>
    </div>
  );
};
